export default __webpack_public_path__ + "static/media/mastercard.94991be4.png";